<template>
    <v-form ref="etapeInfoSpplementaires" id="etapeInfoSpplementaires" v-model="$storeCandidature.etapeInfoSpplementairesValide" lazy-validation>
        <v-container grid-list-md text-xs-center>
            <!--Zone informations des parents-->
            <div v-if="$storeCandidature.sasCandidature.Ecole
                 && $storeCandidature.sasCandidature.Ecole.Id == $storeCandidature.configurationClient.DataIdEcoleEceTech">
                <v-layout row wrap>
                    <h3>Parents :</h3>
                    <hr size="5" width="100%" color="secondary">
                </v-layout>
                <v-layout row wrap xs12>
                    <v-flex xs4>
                        <v-text-field :counter="50"
                                      v-model="$storeCandidature.sasCandidature.InformationsComplementaires.AdresseParents"
                                      :label="$storeCandidature.langueFormulaire == 'en' ? 'Parents address' : 'Adresse parents'"
                                      @change="$storeCandidature.candidatureChanged = true">
                        </v-text-field>
                    </v-flex>
                    <v-flex xs4>
                        <v-text-field :counter="7"
                                      v-model="$storeCandidature.sasCandidature.InformationsComplementaires.CpParents"
                                      :label="$storeCandidature.langueFormulaire == 'en' ? 'Parents Postcode' : 'Code postal parents'"
                                      @change="$storeCandidature.candidatureChanged = true">
                        </v-text-field>
                    </v-flex>
                    <v-flex xs4>
                        <v-text-field :counter="20"
                                      v-model="$storeCandidature.sasCandidature.InformationsComplementaires.VilleParents"
                                      :label="$storeCandidature.langueFormulaire == 'en' ? 'Parents city' : 'Ville parents'"
                                      @change="$storeCandidature.candidatureChanged = true">
                        </v-text-field>
                    </v-flex>
                </v-layout>
                <v-layout row wrap xs12>
                    <v-flex xs4>
                        <v-autocomplete class="pt-0" :items="$storeCandidature.configurationClient.PaysList"
                                        v-model="$storeCandidature.sasCandidature.InformationsComplementaires.PaysParents"
                                        :label="$storeCandidature.langueFormulaire == 'en' ? 'Parents country' : 'Pays parents'"
                                        :item-text="$storeCandidature.langueFormulaire == 'en' ? 'Lang01' : 'Lang00'"
                                        item-value="Id"
                                        return-object
                                        chips
                                        deletable-chips
                                        @change="$storeCandidature.candidatureChanged = true">
                        </v-autocomplete>
                    </v-flex>
                    <v-flex xs4>
                        <v-text-field :counter="14"
                                      prepend-icon="phone"
                                      v-model="$storeCandidature.sasCandidature.InformationsComplementaires.TelephoneParents"
                                      :label="$storeCandidature.langueFormulaire == 'en' ? 'Parents phone' : 'Téléphone parents'"
                                      :rules="[$rules.telephone($storeCandidature.langueFormulaire)]"
                                      title="Exemple : +33612345678, +33 612345678, 0033612345678, 0612345678"
                                      @change="$storeCandidature.candidatureChanged = true">
                        </v-text-field>
                    </v-flex>
                </v-layout>
                <v-layout row wrap xs12>
                    <v-flex xs4 class="center">
                        <v-text-field :counter="30"
                                      v-model="$storeCandidature.sasCandidature.InformationsComplementaires.ProfessionPere"
                                      :label="$storeCandidature.langueFormulaire == 'en' ? 'Father profession' : 'Profession père'"
                                      @change="$storeCandidature.candidatureChanged = true">
                        </v-text-field>
                    </v-flex>
                    <v-flex xs4>
                        <v-text-field :counter="30"
                                      v-model="$storeCandidature.sasCandidature.InformationsComplementaires.EntreprisePere"
                                      :label="$storeCandidature.langueFormulaire == 'en' ? 'Father\'s companie name' : 'Nom entreprise père'"
                                      @change="$storeCandidature.candidatureChanged = true">
                        </v-text-field>
                    </v-flex>
                    <v-flex xs4>
                        <v-text-field :counter="14"
                                      prepend-icon="phone"
                                      v-model="$storeCandidature.sasCandidature.InformationsComplementaires.TelProPere"
                                      :label="$storeCandidature.langueFormulaire == 'en' ? 'Father pro phone' : 'Tel pro. père'"
                                      :rules="[$rules.telephone($storeCandidature.langueFormulaire)]"
                                      title="Exemple : +33612345678, +33 612345678, 0033612345678, 0612345678"
                                      @change="$storeCandidature.candidatureChanged = true">
                        </v-text-field>
                    </v-flex>
                </v-layout>
                <v-layout row wrap xs12>
                    <v-flex xs4>
                        <v-text-field :counter="30"
                                      v-model="$storeCandidature.sasCandidature.InformationsComplementaires.ProfessionMere"
                                      :label="$storeCandidature.langueFormulaire == 'en' ? 'Mother profession' : 'Profession mère'"
                                      @change="$storeCandidature.candidatureChanged = true">
                        </v-text-field>
                    </v-flex>
                    <v-flex xs4>
                        <v-text-field :counter="30"
                                      v-model="$storeCandidature.sasCandidature.InformationsComplementaires.EntrepriseMere"
                                      :label="$storeCandidature.langueFormulaire == 'en' ? 'Mother\'s companie name' : 'Nom entreprise père'"
                                      @change="$storeCandidature.candidatureChanged = true">
                        </v-text-field>
                    </v-flex>
                    <v-flex xs4>
                        <v-text-field :counter="14"
                                      prepend-icon="phone"
                                      v-model="$storeCandidature.sasCandidature.InformationsComplementaires.TelProMere"
                                      :label="$storeCandidature.langueFormulaire == 'en' ? 'Mother pro phone' : 'Tel pro. mère'"
                                      :rules="[$rules.telephone($storeCandidature.langueFormulaire)]"
                                      title="Exemple : +33612345678, +33 612345678, 0033612345678, 0612345678"
                                      @change="$storeCandidature.candidatureChanged = true">
                        </v-text-field>
                    </v-flex>
                </v-layout>
            </div>
            <ComponentListFreresSoeurs v-if="$storeCandidature.sasCandidature.Ecole
                                            && $storeCandidature.sasCandidature.Ecole.Id == $storeCandidature.configurationClient.DataIdEcoleEceTech" />
            <v-layout row wrap xs12 class="mt-3" v-if="$storeCandidature.sasCandidature.Ecole
                      && $storeCandidature.sasCandidature.Ecole.Id != $storeCandidature.configurationClient.DataIdEcoleIsbe
                      && $storeCandidature.sasCandidature.Ecole.Id != $storeCandidature.configurationClient.DataIdEcoleEce
                      && $storeCandidature.sasCandidature.Ecole.Id != $storeCandidature.configurationClient.DataIdEcoleInseecBba
                      && $storeCandidature.sasCandidature.Ecole.Id != $storeCandidature.configurationClient.DataIdEcoleInternational
                      && $storeCandidature.sasCandidature.Ecole.Id != $storeCandidature.configurationClient.DataIdEcoleIum">
                <h3>{{$storeCandidature.langueFormulaire == 'en' ? 'Baccalaureate:' : 'Baccalauréat'}}</h3>
                <hr size="5" width="100%" color="secondary" class='mb-2'>
            </v-layout>
            <v-layout row wrap xs12 v-if="$storeCandidature.sasCandidature.Ecole
                      && $storeCandidature.sasCandidature.Ecole.Id != $storeCandidature.configurationClient.DataIdEcoleIsbe
                      && $storeCandidature.sasCandidature.Ecole.Id != $storeCandidature.configurationClient.DataIdEcoleEce
                      && $storeCandidature.sasCandidature.Ecole.Id != $storeCandidature.configurationClient.DataIdEcoleInseecBba
                      && $storeCandidature.sasCandidature.Ecole.Id != $storeCandidature.configurationClient.DataIdEcoleInternational
                      && $storeCandidature.sasCandidature.Ecole.Id != $storeCandidature.configurationClient.DataIdEcoleIum">
                <v-flex xs4 v-if="$storeCandidature.sasCandidature.Ecole && (
                        $storeCandidature.sasCandidature.Ecole.Id == $storeCandidature.configurationClient.DataIdEcoleEce
                        || $storeCandidature.sasCandidature.Ecole.Id == $storeCandidature.configurationClient.DataIdEcoleEceTech
                        || $storeCandidature.sasCandidature.Ecole.Id == $storeCandidature.configurationClient.DataIdEcoleHeip
                        || $storeCandidature.sasCandidature.Ecole.Id == $storeCandidature.configurationClient.DataIdEcoleIdCeds
                        || $storeCandidature.sasCandidature.Ecole.Id == $storeCandidature.configurationClient.DataIdEcoleEbs
                        || $storeCandidature.dataIdFormulaireCandidature == $storeCandidature.configurationClient.DescIdFormulaireEsceRentreeDecaleeId
                        || $storeCandidature.dataIdFormulaireCandidature == $storeCandidature.configurationClient.DescIdFormulaireEsceInternationaleId
                        )">
                    <v-autocomplete class="pt-0" :items="$storeCandidature.configurationClient.StatutBacList"
                                    v-model="$storeCandidature.sasCandidature.InformationsComplementaires.StatutBac"
                                    :label="$storeCandidature.langueFormulaire == 'en' ? 'Bac status' : 'Statut Bac'"
                                    :item-text="$storeCandidature.langueFormulaire == 'en' ? 'Lang01' : 'Lang00'"
                                    item-value="Id"
                                    return-object
                                    chips
                                    deletable-chips
                                    @change="$storeCandidature.candidatureChanged = true">
                    </v-autocomplete>
                </v-flex>
                <v-flex xs4>
                    <v-autocomplete class="pt-0" :items="$storeCandidature.configurationClient.AnneeObtentionList"
                                    v-model="$storeCandidature.sasCandidature.InformationsComplementaires.AnneeObtention"
                                    :label="$storeCandidature.langueFormulaire == 'en' ? 'Year of graduation' : 'Année d\'obtention'"
                                    :item-text="$storeCandidature.langueFormulaire == 'en' ? 'Lang01' : 'Lang00'"
                                    item-value="Id"
                                    return-object
                                    chips
                                    deletable-chips
                                    @change="$storeCandidature.candidatureChanged = true">
                    </v-autocomplete>
                </v-flex>
                <v-flex xs4>
                    <v-autocomplete class="pt-0" :items="$storeCandidature.configurationClient.MentionList"
                                    v-model="$storeCandidature.sasCandidature.InformationsComplementaires.Mention"
                                    label="Mention"
                                    :item-text="$storeCandidature.langueFormulaire == 'en' ? 'Lang01' : 'Lang00'"
                                    item-value="Id"
                                    return-object
                                    chips
                                    deletable-chips
                                    @change="$storeCandidature.candidatureChanged = true">
                    </v-autocomplete>
                </v-flex>
            </v-layout>
            <v-layout row wrap xs12 v-if="$storeCandidature.sasCandidature.Ecole
                      && $storeCandidature.sasCandidature.Ecole.Id != $storeCandidature.configurationClient.DataIdEcoleIsbe
                      && $storeCandidature.sasCandidature.Ecole.Id != $storeCandidature.configurationClient.DataIdEcoleEce
                      && $storeCandidature.sasCandidature.Ecole.Id != $storeCandidature.configurationClient.DataIdEcoleInseecBba
                      && $storeCandidature.sasCandidature.Ecole.Id != $storeCandidature.configurationClient.DataIdEcoleInternational
                      && $storeCandidature.sasCandidature.Ecole.Id != $storeCandidature.configurationClient.DataIdEcoleIum ">
                <v-flex xs4>
                    <v-autocomplete class="pt-0" :items="$storeCandidature.configurationClient.SerieList"
                                    v-model="$storeCandidature.sasCandidature.InformationsComplementaires.Serie"
                                    :label="$storeCandidature.langueFormulaire == 'en' ? 'Series' : 'Série'"
                                    :item-text="$storeCandidature.langueFormulaire == 'en' ? 'Lang01' : 'Lang00'"
                                    item-value="Id"
                                    return-object
                                    chips
                                    deletable-chips
                                    @change="$storeCandidature.candidatureChanged = true">
                    </v-autocomplete>
                </v-flex>
                <v-flex xs4 v-if="$storeCandidature.sasCandidature.Ecole
                        && $storeCandidature.sasCandidature.Ecole.Id != $storeCandidature.configurationClient.DataIdEcoleEce">
                    <v-text-field :counter="20"
                                  v-model="$storeCandidature.sasCandidature.InformationsComplementaires.Specialite"
                                  :label="$storeCandidature.langueFormulaire == 'en' ? 'Specialty' : 'Spécialité'"
                                  @change="$storeCandidature.candidatureChanged = true">
                    </v-text-field>
                </v-flex>
                <v-flex xs4 v-if="$storeCandidature.sasCandidature.Ecole
                        && $storeCandidature.sasCandidature.Ecole.Id != $storeCandidature.configurationClient.DataIdEcoleEce">
                    <v-autocomplete class="pt-0" :items="$storeCandidature.configurationClient.OptionList"
                                    v-model="$storeCandidature.sasCandidature.InformationsComplementaires.Option"
                                    label="Option"
                                    :item-text="$storeCandidature.langueFormulaire == 'en' ? 'Lang01' : 'Lang00'"
                                    item-value="Id"
                                    return-object
                                    chips
                                    deletable-chips
                                    @change="$storeCandidature.candidatureChanged = true">
                    </v-autocomplete>
                </v-flex>
            </v-layout>
            <v-layout row wrap xs12 v-if="$storeCandidature.sasCandidature.Ecole
                      && $storeCandidature.sasCandidature.Ecole.Id != $storeCandidature.configurationClient.DataIdEcoleIsbe
                      && $storeCandidature.sasCandidature.Ecole.Id != $storeCandidature.configurationClient.DataIdEcoleInseecBba
                      && $storeCandidature.sasCandidature.Ecole.Id != $storeCandidature.configurationClient.DataIdEcoleIum
                      && $storeCandidature.sasCandidature.Ecole.Id != $storeCandidature.configurationClient.DataIdEcoleInternational
                      && $storeCandidature.sasCandidature.Ecole.Id != $storeCandidature.configurationClient.DataIdEcoleEce">
                <v-flex xs4>
                    <v-text-field :counter="20"
                                  v-model="$storeCandidature.sasCandidature.InformationsComplementaires.NumIne"
                                  label="N° INE"
                                  @change="$storeCandidature.candidatureChanged = true">
                    </v-text-field>
                </v-flex>
                <v-flex xs4>
                    <v-autocomplete class="pt-0" :items="$storeCandidature.configurationClient.AcademieList"
                                    v-model="$storeCandidature.sasCandidature.InformationsComplementaires.Academie"
                                    :label="$storeCandidature.langueFormulaire == 'en' ? 'Academy' : 'Académie'"
                                    :item-text="$storeCandidature.langueFormulaire == 'en' ? 'Lang01' : 'Lang00'"
                                    item-value="Id"
                                    return-object
                                    chips
                                    deletable-chips
                                    @change="$storeCandidature.candidatureChanged = true">
                    </v-autocomplete>
                </v-flex>
            </v-layout>
            <div v-if="$storeCandidature.sasCandidature.Ecole &&
                 $storeCandidature.sasCandidature.Ecole.Id == $storeCandidature.configurationClient.DataIdEcoleEceTech">
                <v-layout row wrap xs14>
                    <v-flex xs2>
                        <v-text-field :label="$storeCandidature.langueFormulaire == 'en' ? 'Overall average' : 'Moyenne générale'"
                                      v-model="$storeCandidature.sasCandidature.InformationsComplementaires.MoyenneGeneral"
                                      type="number" min="0" max="20"
                                      suffix="/ 20" class="px-4"
                                      :rules="[$rules.max20($storeCandidature.langueFormulaire)]"
                                      @change="$storeCandidature.candidatureChanged = true">
                        </v-text-field>
                    </v-flex>
                    <v-flex xs2 v-if="$storeCandidature.sasCandidature.Ecole && $storeCandidature.sasCandidature.Ecole.Id != $storeCandidature.configurationClient.DataIdEcoleEce">
                        <v-text-field :label="$storeCandidature.langueFormulaire == 'en' ? 'French written note' : 'Note français écrit'"
                                      v-model="$storeCandidature.sasCandidature.InformationsComplementaires.NoteFrancaisEcrit"
                                      type="number" min="0" max="20"
                                      suffix="/ 20" class="px-4"
                                      :rules="[$rules.max20($storeCandidature.langueFormulaire)]"
                                      @change="$storeCandidature.candidatureChanged = true">
                        </v-text-field>
                    </v-flex>
                    <v-flex xs2 v-if="$storeCandidature.sasCandidature.Ecole
                            && $storeCandidature.sasCandidature.Ecole.Id != $storeCandidature.configurationClient.DataIdEcoleEce">
                        <v-text-field :label="$storeCandidature.langueFormulaire == 'en' ? 'French oral note' : 'Note français oral'"
                                      v-model="$storeCandidature.sasCandidature.InformationsComplementaires.NoteFrancaisOral"
                                      type="number" min="0" max="20"
                                      suffix="/ 20" class="px-4"
                                      :rules="[$rules.max20($storeCandidature.langueFormulaire)]"
                                      @change="$storeCandidature.candidatureChanged = true">
                        </v-text-field>
                    </v-flex>
                    <v-flex xs2 v-if="$storeCandidature.sasCandidature.Ecole
                            && $storeCandidature.sasCandidature.Ecole.Id != $storeCandidature.configurationClient.DataIdEcoleEce">
                        <v-text-field :label="$storeCandidature.langueFormulaire == 'en' ? 'Math Note' : 'Note Math'"
                                      v-model="$storeCandidature.sasCandidature.InformationsComplementaires.NoteMath"
                                      type="number" max="20"
                                      suffix="/ 20" class="px-4"
                                      :rules="[$rules.max20($storeCandidature.langueFormulaire)]"
                                      @change="$storeCandidature.candidatureChanged = true">
                        </v-text-field>
                    </v-flex>
                    <v-flex xs2 v-if="$storeCandidature.sasCandidature.Ecole
                            && $storeCandidature.sasCandidature.Ecole.Id != $storeCandidature.configurationClient.DataIdEcoleEce">
                        <v-text-field :label="$storeCandidature.langueFormulaire == 'en' ? 'Physics Note' : 'Note Physique'"
                                      v-model="$storeCandidature.sasCandidature.InformationsComplementaires.NotePhysique"
                                      type="number" min="0" max="20"
                                      suffix="/ 20" class="px-4"
                                      :rules="[$rules.max20($storeCandidature.langueFormulaire)]"
                                      @change="$storeCandidature.candidatureChanged = true">
                        </v-text-field>
                    </v-flex>
                    <v-flex xs2 v-if="$storeCandidature.sasCandidature.Ecole
                            && $storeCandidature.sasCandidature.Ecole.Id != $storeCandidature.configurationClient.DataIdEcoleEce">
                        <v-text-field :label="$storeCandidature.langueFormulaire == 'en' ? 'English Note' : 'Note Anglais'"
                                      v-model="$storeCandidature.sasCandidature.InformationsComplementaires.NoteAnglais"
                                      type="number" min="0" max="20"
                                      suffix="/ 20" class="px-4"
                                      :rules="[$rules.max20($storeCandidature.langueFormulaire)]"
                                      @change="$storeCandidature.candidatureChanged = true">
                        </v-text-field>
                    </v-flex>

                    <v-flex xs2 v-if="$storeCandidature.sasCandidature.Ecole.Id == $storeCandidature.configurationClient.DataIdEcoleEceTech">
                        <v-text-field :label="$storeCandidature.langueFormulaire == 'en' ? 'TPE Note' : 'Note TPE'"
                                      v-model="$storeCandidature.sasCandidature.InformationsComplementaires.NoteTPE"
                                      type="number" min="0" max="20"
                                      suffix="/ 20" class="px-4"
                                      :rules="[$rules.max20($storeCandidature.langueFormulaire)]"
                                      @change="$storeCandidature.candidatureChanged = true">
                        </v-text-field>
                    </v-flex>
                </v-layout>
            </div>
            <!--Comment avez-vous connu l'école? : que pour Esce ou Ium-->
            <div v-if="$storeCandidature.sasCandidature.Ecole &&
                 ($storeCandidature.sasCandidature.Ecole.Id == $storeCandidature.configurationClient.DataIdEcoleEsce ||
                 $storeCandidature.sasCandidature.Ecole.Id == $storeCandidature.configurationClient.DataIdEcoleSupDigital  ||
                 $storeCandidature.sasCandidature.Ecole.Id == $storeCandidature.configurationClient.DataIdEcoleSupDePub ||
                  $storeCandidature.sasCandidature.Ecole.Id == $storeCandidature.configurationClient.DataIdEcoleIdSupCreation ||
                 $storeCandidature.sasCandidature.Ecole.Id == $storeCandidature.configurationClient.DataIdEcoleSupCareer)
                 || $storeCandidature.DataIdEcoleIdDBA == $storeCandidature.configurationClient.DataIdEcoleIdDBA ">
                <v-layout row wrap xs12>
                    <h3>{{$storeCandidature.langueFormulaire == 'en' ? 'How did you first hear about school?' : 'Comment avez-vous connu l\'école ?'}}</h3>
                    <hr size="5" width="100%" color="secondary" class='mb-2'>
                </v-layout>
                <v-layout row wrap xs12>
                    <v-flex xs4>
                        <v-flex xs12>
                            <v-autocomplete class="pt-0" :items="$storeCandidature.configurationClient.SourceDeclarativeList"
                                            v-model="$storeCandidature.sasCandidature.InformationsComplementaires.SourceDeclarative"
                                            :label="$storeCandidature.langueFormulaire == 'en' ? 'I have known you through' : 'J’ai connu l’école'"
                                            :item-text="$storeCandidature.langueFormulaire == 'en' ? 'Lang01' : 'Lang00'"
                                            item-value="Id"
                                            return-object
                                            chips
                                            deletable-chips
                                            @change="$storeCandidature.candidatureChanged = true">
                            </v-autocomplete>
                        </v-flex>
                        <v-flex xs12>
                            <v-text-field :counter="100"
                                          v-model="$storeCandidature.sasCandidature.InformationsComplementaires.PrecisonSource"
                                          :label="$storeCandidature.langueFormulaire == 'en' ? 'Why do you apply to' : 'Précisez'"
                                          @change="$storeCandidature.candidatureChanged = true">
                            </v-text-field>
                        </v-flex>
                    </v-flex>
                    <v-flex xs8>
                        <v-textarea filled
                                    v-model="$storeCandidature.sasCandidature.InformationsComplementaires.Notes"
                                    :label="$storeCandidature.langueFormulaire == 'en' ? 'Comments' : 'Commentaires'"
                                    @change="$storeCandidature.candidatureChanged = true">
                        </v-textarea>
                    </v-flex>
                </v-layout>
            </div>

            <div id="terminale" v-if="$storeCandidature.sasCandidature.Ecole &&
                 ($storeCandidature.sasCandidature.Ecole.Id != $storeCandidature.configurationClient.DataIdEcoleIsbe
                 && $storeCandidature.sasCandidature.Ecole.Id != $storeCandidature.configurationClient.DataIdEcoleEbs
                 && $storeCandidature.dataIdFormulaireCandidature != $storeCandidature.configurationClient.DescIdFormulaireEsceRentreeDecaleeId
                 && $storeCandidature.dataIdFormulaireCandidature != $storeCandidature.configurationClient.DescIdFormulaireEsceInternationaleId
                 && $storeCandidature.sasCandidature.Ecole.Id != $storeCandidature.configurationClient.DataIdEcoleIdCeds
                 && $storeCandidature.sasCandidature.Ecole.Id != $storeCandidature.configurationClient.DataIdEcoleIum
                 && $storeCandidature.dataIdFormulaireCandidature != $storeCandidature.configurationClient.DescIdFormulaireBachelorsBba
                 && $storeCandidature.sasCandidature.Ecole.Id != $storeCandidature.configurationClient.DataIdEcoleInternational
                 && $storeCandidature.sasCandidature.Ecole.Id != $storeCandidature.configurationClient.DataIdEcoleHeip)
                 && ($storeCandidature.dataIdFormulaireCandidature != $storeCandidature.configurationClient.DescIdFormulaireMscEsce)
                 ">
                <v-layout row wrap>
                    <h3>{{$storeCandidature.langueFormulaire == 'en' ? 'Terminal:' : 'Terminale :'}}</h3>
                    <hr size="5" width="100%" color="secondary" class='mb-2'>
                </v-layout>
                <v-layout row wrap xs12>
                    <v-flex xs4>
                        <v-autocomplete class="pt-0" :items="$storeCandidature.configurationClient.AnneeScolaireList"
                                        v-model="$storeCandidature.sasCandidature.ParcoursScolaireTerminale.AnneeTerminale"
                                        :label="$storeCandidature.langueFormulaire == 'en' ? 'Academic Year' : 'Année scolaire'"
                                        :item-text="$storeCandidature.langueFormulaire == 'en' ? 'Lang01' : 'Lang00'"
                                        item-value="Id"
                                        :rules="[$rules.required($storeCandidature.langueFormulaire)]"
                                        return-object
                                        chips
                                        deletable-chips
                                        @change="$storeCandidature.candidatureChanged = true">
                        </v-autocomplete>
                    </v-flex>
                    <v-flex xs2 class="pl-2">
                        <v-switch :label="$storeCandidature.langueFormulaire == 'en' ? 'Repetition' : 'Redoublement'" v-model="$storeCandidature.sasCandidature.ParcoursScolaireTerminale.RedoublementTerminale" @change="$storeCandidature.candidatureChanged = true"></v-switch>
                    </v-flex>
                </v-layout>
                <v-layout row wrap xs12>
                    <v-flex xs4>
                        <v-layout row wrap xs12>
                            <v-flex :class="{xs6 : !$storeCandidature.sasCandidature.ParcoursScolaireTerminale.EtablissementTerminale}"
                                    v-if="!$storeCandidature.sasCandidature.ParcoursScolaireTerminale.EtablissementAutre">
                                <v-autocomplete class="pt-1" :items="$storeCandidature.etablissementFrequenteTerminaleList"
                                                v-model="$storeCandidature.sasCandidature.ParcoursScolaireTerminale.EtablissementTerminale"
                                                :label="$storeCandidature.langueFormulaire == 'en' ? 'Institution name' : 'Etablissement fréquenté'"
                                                item-text="Label"
                                                item-value="Id"
                                                :placeholder="$storeCandidature.langueFormulaire == 'en' ? 'Enter the name of the institution.' : 'Saisissez le nom de l\'établissement.'"
                                                @change="majEtabilssementTerminale()"
                                                :search-input.sync="search"
                                                @keyup="debounceInputTerminal"
                                                :loading="isLoading"
                                                return-object
                                                chips
                                                deletable-chips>
                                    <template #no-data>
                                        <div v-if="search == null || search == ''" class="pt-2 pb-2 pl-2">{{$storeCandidature.langueFormulaire == 'en' ? 'Enter the name of the institution.' : 'Saisissez le nom de l\'établissement.'}}</div>
                                        <div v-else class="pt-2 pb-2 pl-2">{{$storeCandidature.langueFormulaire == 'en' ? 'No results found' : 'Aucun établissment trouvé'}}</div>
                                    </template>
                                </v-autocomplete>
                            </v-flex>
                            <v-flex :class="{xs6 : !$storeCandidature.sasCandidature.ParcoursScolaireTerminale.EtablissementAutre}"
                                    v-if="!$storeCandidature.sasCandidature.ParcoursScolaireTerminale.EtablissementTerminale">
                                <v-text-field v-model="$storeCandidature.sasCandidature.ParcoursScolaireTerminale.EtablissementAutre"
                                              :label="$storeCandidature.langueFormulaire == 'en' ? 'Institution name (If not in the list)' : 'Etablissement (Si pas dans la liste)'"
                                              @change="$storeCandidature.candidatureChanged = true">
                                </v-text-field>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                    <v-flex xs4>
                        <v-text-field :counter="8"
                                      v-model="$storeCandidature.sasCandidature.ParcoursScolaireTerminale.CpTerminale"
                                      :label="$storeCandidature.langueFormulaire == 'en' ? 'Institution postcode' : 'Code postal établissement'"
                                      @change="$storeCandidature.candidatureChanged = true">
                        </v-text-field>
                    </v-flex>
                    <v-flex xs4>
                        <v-text-field :counter="30"
                                      v-model="$storeCandidature.sasCandidature.ParcoursScolaireTerminale.VilleTerminale"
                                      :label="$storeCandidature.langueFormulaire == 'en' ? 'Institution city' : 'Ville établissement'"
                                      @change="$storeCandidature.candidatureChanged = true">
                        </v-text-field>
                    </v-flex>
                </v-layout>
            </div>
            <ComponentListParcoursScolaire v-if="$storeCandidature.sasCandidature.Ecole
                                           && $storeCandidature.sasCandidature.Ecole.Id != $storeCandidature.configurationClient.DataIdEcoleEce"
                                           class="mt-3" />
            <div v-if="$storeCandidature.sasCandidature.Ecole.Id == $storeCandidature.configurationClient.DataIdEcoleInternational">
                <br />
                <!--Zone informations desLangues-->
                <ComponentListLangues />
            </div>

        </v-container>
    </v-form>
</template>
<script>
    import ComponentListFreresSoeurs from './CandidatureListeFrereSoeur.vue'
    import ComponentListParcoursScolaire from './CandidatureListeParcoursScolaire.vue'
    import ComponentListLangues from './CandidatureListeLangues.vue'
    import lodash from 'lodash';  
    import { TIMEOUT_ETABLISSEMENT } from '../constants'

    export default {
        components: {
            ComponentListFreresSoeurs,
            ComponentListParcoursScolaire,
            ComponentListLangues
        },

        data() {
            return {
                // Réaffecter l'objet global pour forcer la maj en temps réel
                $storeCandidature: this.$storeCandidature,
                isLoading: false,
                etablissementWatcher: null,
                search: '',
            }
        },
        methods: {

            // Recherche des etablissements.
            debounceInputTerminal: lodash.debounce(async function () {

                // Afficher le chargement.
                this.isLoading = true

                if (this.$storeCandidature) {

                    await this.$storeCandidature.chargerListesEtablissementFrequenteTerminal(this.search);

                    // Ne plus afficher.
                    this.isLoading = false
                }
            }, TIMEOUT_ETABLISSEMENT),

            // Maj cp ville terminale
            majEtabilssementTerminale() {
                if (this.$storeCandidature.sasCandidature.ParcoursScolaireTerminale.EtablissementTerminale) {
                    this.$storeCandidature.sasCandidature.ParcoursScolaireTerminale.CpTerminale = this.$storeCandidature.sasCandidature.ParcoursScolaireTerminale.EtablissementTerminale.Cp
                    this.$storeCandidature.sasCandidature.ParcoursScolaireTerminale.VilleTerminale = this.$storeCandidature.sasCandidature.ParcoursScolaireTerminale.EtablissementTerminale.Ville
                }

                this.$storeCandidature.candidatureChanged = true
            },

            // Push le EtablissementTerminale à la liste pour ne pas que l'utilisateur voit une valeur vide.
            pushEtablissementTerminale() {

                if (this.$storeCandidature.sasCandidature.ParcoursScolaireTerminale
                    && this.$storeCandidature.sasCandidature.ParcoursScolaireTerminale.EtablissementTerminale) {

                    this.$storeCandidature.etablissementFrequenteTerminaleList.push({ ...this.$storeCandidature.sasCandidature.ParcoursScolaireTerminale.EtablissementTerminale })
                }

                // Kill du watcher  quand la valeur a pu être récupéré une fois ou que la candidature n'a pas d'identifient.
                if (this.$storeCandidature.sasCandidature.ParcoursScolaireTerminale.EtablissementTerminale
                    || !this.$storeCandidature.sasCandidature.IdCrypte) {
                    this.etablissementWatcher();
                }
            },
        },

        mounted() {
            if (this.$refs.etapeInfoSpplementaires) {
                this.$refs.etapeInfoSpplementaires.validate()
            }

            // Mise en place d'un watcher provisoire.
            this.etablissementWatcher = this.$watch('$storeCandidature.sasCandidature.ParcoursScolaireTerminale', () => {
                this.pushEtablissementTerminale();
            });
        },
    }
</script>

